export const isUrlWhitelisted = (url, whitelistedHosts = []) => {
    if (!url) {
        return false;
    }
    const isRelativeUrl = url.startsWith("/");
    if (isRelativeUrl || whitelistedHosts.length === 0) {
        return true;
    }
    const urlHost = new URL(url).host;
    return whitelistedHosts.includes(urlHost);
};
//# sourceMappingURL=isUrlWhitelisted.js.map